// images
import blogImg1 from "../images/blog/img-1.jpg";
import blogImg2 from "../images/blog/img-2.jpg";
import blogImg3 from "../images/blog/img-3.jpg";

import blogSingleImg1 from "../images/blog/blog-single/img-1.jpg";
import blogSingleImg2 from "../images/blog/blog-single/img-2.jpg";
import blogSingleImg3 from "../images/blog/blog-single/img-3.jpg";

const blogs = [
  {
    id: "1",
    title: "Empowering Our Community Through Engagement",
    slug: "empowering-our-community",
    screens: blogImg1,
    description:
      "Discover Taisha’s approach to empowering Erie County’s 2nd District through transparent communication and community-driven initiatives.",
    author: "Campaign Team",
    create_at: "5 Nov 2023",
    blogSingleImg: blogSingleImg1,
    comment: "42",
    day: "5",
    month: "NOVEMBER",
    blClass: "format-standard-image",
    animation: "1200",
  },
  {
    id: "2",
    title: "Economic Growth & Job Creation for a Thriving Future",
    slug: "economic-growth-job-creation",
    screens: blogImg2,
    description:
      "Learn how Taisha plans to boost economic development and create sustainable job opportunities in Erie County’s 2nd District.",
    author: "Campaign Team",
    create_at: "12 Nov 2023",
    blogSingleImg: blogSingleImg2,
    comment: "37",
    day: "12",
    month: "NOVEMBER",
    blClass: "format-standard-image",
    animation: "1400",
  },
  {
    id: "3",
    title: "Investing in Education & Youth Empowerment",
    slug: "education-youth-empowerment",
    screens: blogImg3,
    description:
      "Taisha’s vision for education includes mentorship programs, vocational training, and creating pathways to success for all youth in our district.",
    author: "Campaign Team",
    create_at: "19 Nov 2023",
    blogSingleImg: blogSingleImg3,
    comment: "29",
    day: "19",
    month: "NOVEMBER",
    blClass: "format-standard-image",
    animation: "1600",
  },
];

export default blogs;
